import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Container, Typography } from '@mui/material';
// components
import Logo from '../components/Logo';
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import RecoverForm from '../components/authentication/login/RecoverForm';

// ----------------------------------------------------------------------
const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function RecoverPassword() {
  return (
    <RootStyle title="Recuperar contraseña">
      <MHidden width="mdDown">
        <SectionStyle>
        <RouterLink to="/">
            <Logo />
          </RouterLink>
          <img alt="register" src="/static/logo_jl.png" />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Recuperar contraseña
            </Typography>
          </Stack>
          <RecoverForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}